export const GAME_CATEGORIES = [
  { id: 'all', name: '全部', icon: 'all' },
  { id: 'action', name: '动作冒险', icon: 'action' },
  { id: 'rpg', name: '角色扮演', icon: 'rpg' },
  { id: 'strategy', name: '策略塔防', icon: 'strategy' },
  { id: 'puzzle', name: '休闲益智', icon: 'puzzle' },
  { id: 'sports', name: '体育竞速', icon: 'sports' },
  { id: 'shooting', name: '飞行射击', icon: 'shooting' },
  { id: 'card', name: '棋牌桌游', icon: 'card' },
  { id: 'simulation', name: '模拟经营', icon: 'simulation' },
  { id: 'music', name: '音乐节奏', icon: 'music' },
  { id: 'girl', name: '女性向', icon: 'girl' }
]

export const RANK_TABS = [
  { key: 'hot', name: '热门榜' },
  { key: 'new', name: '新游榜' },
  { key: 'recommend', name: '推荐榜' },
  { key: 'popular', name: '人气榜' }
]

export const HOME_TABS = [
  { key: 'recommend', name: '推荐' },
  { key: 'hot', name: '热门' },
  { key: 'new', name: '最新' }
]

export const LEVEL_CONFIG = [
  { level: 1, name: '青铜玩家', minExp: 0, icon: '🥉', color: '#CD7F32' },
  { level: 2, name: '白银玩家', minExp: 100, icon: '🥈', color: '#C0C0C0' },
  { level: 3, name: '黄金玩家', minExp: 300, icon: '🥇', color: '#FFD700' },
  { level: 4, name: '铂金玩家', minExp: 800, icon: '💎', color: '#E5E4E2' },
  { level: 5, name: '钻石玩家', minExp: 2000, icon: '👑', color: '#B9F2FF' },
  { level: 6, name: '王者玩家', minExp: 5000, icon: '🏆', color: '#FF6B35' },
  { level: 7, name: '荣耀王者', minExp: 12000, icon: '🌟', color: '#FFD700' }
]

export const STORAGE_KEYS = {
  USER_INFO: 'gc_user_info',
  USER_TOKEN: 'gc_user_token',
  LOGIN_DATA: 'gc_login_data',
  SEARCH_HISTORY: 'gc_search_history',
  GAME_RECORDS: 'gc_game_records',
  CMCC_TOKEN: 'gc_cmcc_token'
}
